import { useQuery } from 'react-query'

import { getExpenseLineItemFormDataUseCase } from '@webapp/modules/expense/business-logic/use-cases/GetExpenseLineItemFormDataUseCase'
import {
  ExpenseFormReimbursementCustomizations,
  type ExpenseFormReimbursementCustomization,
} from '@webapp/modules/expense/entities/enums'
import { expenseReportQueryConfig } from '@webapp/modules/expense/query-configs/expenseReport'

interface UseEditExpenseLineItemDrawerParams {
  requesterId: number
}

interface UseEditExpenseLineItemDrawerReturn {
  data: {
    reimbursementSetting: ExpenseFormReimbursementCustomization
  }
  states: {
    isFormDataLoading: boolean
  }
}

export const useEditExpenseLineItemDrawer = ({
  requesterId,
}: UseEditExpenseLineItemDrawerParams): UseEditExpenseLineItemDrawerReturn => {
  const { data, isLoading: isFormDataLoading } = useQuery({
    queryKey: expenseReportQueryConfig.lineItemFormData(requesterId).queryKey,
    queryFn: () =>
      getExpenseLineItemFormDataUseCase.execute({ userId: requesterId }),
  })

  const reimbursementSetting =
    data?.reimbursementSetting ??
    ExpenseFormReimbursementCustomizations.DEFAULT_YES

  return {
    data: {
      reimbursementSetting,
    },
    states: {
      isFormDataLoading,
    },
  }
}
